import {qs, qsa, appendScript, appendStyle} from '../utils/domUtils';
import initTable from "./table-ajax";

const initDataTableLibs = async () => {
    const tableTypes = ['ajax'];

    // initialising default libs
    await appendScript('/vendors/js/tables/datatable/jquery.dataTables.min.js')
    await appendScript('/vendors/js/tables/datatable/dataTables.bootstrap5.min.js')
    await appendScript('/vendors/js/tables/datatable/dataTables.responsive.min.js')
    await appendScript('/vendors/js/tables/datatable/responsive.bootstrap5.min.js')
    await appendScript('/vendors/js/tables/datatable/datatables.buttons.min.js')

    //add datatable styles scripts
    appendStyle('/vendors/css/tables/datatable/dataTables.bootstrap5.min.css')
    appendStyle('/vendors/css/tables/datatable/responsive.bootstrap5.min.css')
    appendStyle('/vendors/css/tables/datatable/buttons.bootstrap5.min.css')
    // Init custom
    tableTypes.forEach( type => {
        let typeTables = qsa(`.datatables-${type}`);
        if (typeTables.length > 0){
            typeTables.forEach(async (tableEl) => {
                initTable(tableEl);
            })
        }
    })

    return 1;
}

const initDataTable = () => {
    return new Promise(resolve => {
        if (qsa('.datatable').length > 0){
            initDataTableLibs().then(() => {
                resolve(1);
            })
        }
    })
}

export default initDataTable;
